import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import PopupCard from '../popup-card/popup-card';

@Component({
    name: 'pull-out-more-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'popup-card': PopupCard,
    },
})

export default class PullOutMoreCard extends Vue {

    // ----------------------------------------------------------------------------
    // Properties
    @Prop()
    private pullOutMoreData: any;

    @Prop()
    private headerMenus: any;

    private isShowPopup: boolean = false;

    private content: any = {};

    private cardName: string = '';

    private selectedContent = [];

    private filteredList: any = {};

    @Watch('headerMenus', { deep: true })
    private onChangeMenus(value: any) {
        this.onLoadData(value);
    }

    private created() {
        this.onLoadData();
    }

    // ------------------------------------------------------------------------------
    // Methods

    private onLoadData(value = this.pullOutMoreData) {
        const filteredList: any = {};
        const activeMenus = this.headerMenus.filter((menu: any) => menu.isActive);
        if (activeMenus.length) {
            activeMenus.forEach((activeMenu: any) => {
                for (const metaHeader in this.pullOutMoreData) {
                    if (this.pullOutMoreData.hasOwnProperty(metaHeader)) {
                        if (!filteredList[metaHeader]) {
                            filteredList[metaHeader] = {};
                        }
                        const listOfHeader = Object.keys(this.pullOutMoreData[metaHeader]);
                        if (listOfHeader.length) {
                            listOfHeader.forEach(
                                (availablemeta: any) => {
                                    if (activeMenu.keyList.indexOf(availablemeta) !== -1) {
                                        if (availablemeta === 'subject'
                                            || availablemeta === 'course'
                                            || availablemeta === 'Audience'
                                            || availablemeta === 'standard'
                                            || availablemeta === 'domain') {
                                            if (Array.isArray(this.pullOutMoreData[metaHeader][availablemeta])) {
                                                if (availablemeta === 'standard') {
                                                    this.pullOutMoreData[metaHeader][availablemeta] = (
                                                        this.pullOutMoreData[metaHeader][availablemeta].map(
                                                            (item: any) => `<span class="standard-tip" title="${item.title
                                                                || ''}">${item.code}</span>`)).join('');
                                                } else {
                                                    this.pullOutMoreData[metaHeader][availablemeta] = (
                                                        this.pullOutMoreData[metaHeader][availablemeta]).toString();
                                                }

                                            }
                                        }

                                        if (availablemeta === 'summary') {
                                            this.content.summary = this.pullOutMoreData[metaHeader][availablemeta];
                                            this.pullOutMoreData[metaHeader][availablemeta] =
                                                this.pullOutMoreData[metaHeader][availablemeta] &&
                                                    this.pullOutMoreData[metaHeader][availablemeta].length
                                                    ? this.pullOutMoreData[metaHeader][availablemeta][0].shortSummary : '--';
                                        }
                                        if (availablemeta === 'transcript') {
                                            this.content.transcript = this.pullOutMoreData[metaHeader][availablemeta];
                                            this.pullOutMoreData[metaHeader][availablemeta] =
                                                this.pullOutMoreData[metaHeader][availablemeta] &&
                                                    this.pullOutMoreData[metaHeader][availablemeta].length
                                                    ? this.pullOutMoreData[metaHeader][availablemeta][0].shortTranscript
                                                    : '--';
                                        }
                                        if (availablemeta === 'phrasecloud') {
                                            this.content.phrasecloud = this.pullOutMoreData[metaHeader][availablemeta];
                                            const imageString = this.pullOutMoreData[metaHeader][availablemeta] &&
                                                this.pullOutMoreData[metaHeader][availablemeta].length
                                                ? this.pullOutMoreData[metaHeader][availablemeta][0].image : '--';

                                            (async () => {
                                                const pharseImg = document.createElement('img');
                                                pharseImg.src = imageString;
                                                pharseImg.onload = () => {
                                                    this.$el.querySelector
                                                    (`.class-phrasecloud`)!.innerHTML = pharseImg.outerHTML;
                                                };
                                                pharseImg.onerror = () => {
                                                    this.$el.querySelector(`.class-phrasecloud`)!.innerHTML = `<span class="pharse-img-text">--</span>`;
                                                };
                                            })();

                                        }
                                        filteredList[metaHeader][availablemeta] = {
                                            value: this.pullOutMoreData[metaHeader][availablemeta],
                                            color: activeMenu.color,
                                        };
                                    }
                                });

                        }
                    }
                }
            });
        }
        this.filteredList = filteredList;
    }

    private showPopup(content: string) {
        this.cardName = content;
        this.selectedContent = this.content[content];
        this.isShowPopup = !this.isShowPopup;
    }

}
